import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const CreateTemporaryQuoteModalProductFragmentDoc = gql`
  fragment CreateTemporaryQuoteModalProduct on ProductInterface {
    id
    brand
    itemDescription
    ...ProductItemProduct
  }
  ${ProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.CreateTemporaryQuoteModalProductFragment, unknown>
